import { AfterContentInit, Component } from '@angular/core';

@Component({
  selector: 'app-mobile-home',
  templateUrl: './mobile-home.component.html',
  styleUrls: ['./mobile-home.component.css']
})
export class MobileHomeComponent implements AfterContentInit {
  constructor() {

  }

  ngAfterContentInit() {
    // force the mobile page to be landscape
    this.updateOrientationStyles();

    document.body.focus();

    // Listen for orientation changes
    screen.orientation.addEventListener('change', this.updateOrientationStyles);
  }

  updateOrientationStyles() {
    if (screen.orientation.type.startsWith('portrait')) {
      document.body.style.transform = 'rotate(-90deg)';
      document.body.style.transformOrigin = 'center';
      document.body.style.width = '100vh';
      document.body.style.height = '100vw';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.transform = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
    }
  }
}
